import { Component, OnInit } from '@angular/core';
import { CommonUtilitiesService } from "../common-utilities.service";
import * as $ from 'jquery';
import { constants } from '../constants';
import { FormGroup, FormBuilder, Validators, MaxLengthValidator } from '@angular/forms';
import { Router } from '@angular/router';
import { ReleaseLineEquipService } from "./release-line-equip.service";
declare var $: any;
@Component({
  selector: 'app-release-line-equip',
  templateUrl: './release-line-equip.component.html',
  styleUrls: ['./release-line-equip.component.scss']
})
export class ReleaseLineEquipComponent implements OnInit {
  numericPattern = "";
  alphanumericPattern = "";
  emailPattern = "";
  datePattern = "";
  releaseLineForm: FormGroup;
  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  isModalReload = false;
  //dato quemado que viene de WS
  lineaSolicitada = "";
  //Campos de los inputs
  keyNumber: any;
  validarPreguntas: any;
  //Ventanas Modales
  isShowModalConfirmation = false; //Modal opciones "intertar nuevamente" o "probar otra manera"
  isShowModalValid = false;
  isShowModalInvalidAnswer = false;
  modalTitleConfirmation = "";
  modalContentKeyIncorrect = "";
  modalContentKeyIncorrectOpt = "";
  modalTitleConfirmationRelease = "";
  //Formulario de preguntas
  isIncorrectKey = false;
  listQuestions = [];
  questionSelected = {};
  questionSelectedModel = [];
  //carga datos correspondientes a la linea seleccionada
  selectedLine = false;
  imei = constants.IMEI_TITLE;
  phoneBrand: any;
  phoneImei: any;
  listLineData: any;
  listLines: any;
  isBtnDisabled = false;
  response: any;
  isLoadingLines = false;
  isLoadingQuestion = false;
  types = {
    line: constants.STRING_LINE,
    equip: constants.STRING_EQUIP,
    line_equip: constants.STRING_LINE_EQUIP
  }
  selectedType = constants.STRING_LINE;

  constructor(public LANG: CommonUtilitiesService, private formbuilder: FormBuilder, private _router: Router, private releaseLineEquipService: ReleaseLineEquipService) { }
  /**
  * Description: Método que inicializa y carga las variables del formulario de liberación
  * Autor: Steven Sterling
  * @param N/A
  * @return N/A
  */
  ngOnInit() {
    this.getClientLinesLists();
    this.chekckOptionsSelected();
    //llamado al metodo que llena los tooltip
    this.setTooltips();
    //validaciones de formulario
    this.numericPattern = constants.REGEX_NUMERIC_PATTERN;
    this.alphanumericPattern = constants.REGEX_ALPHANUMERIC_PATTERN;
    this.emailPattern = constants.REGEX_EMAIL_PATTERN;
    //se inicializan los inputs para las validaciones con sus respectivas expresiones regulares
    this.releaseLineForm = this.formbuilder.group({
      inputPhone: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      inputEmail: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      inputKeyNumber: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      inputLines: ['', [Validators.required]],
    });

  }
  /**
  * Description: Método que valida que los datos esten ingresados correctamente 
  * Autor: Steven Sterling
  * @param N/A
  * @return N/A
  */
  releaseValidation() {

    if (this.releaseLineForm.get('inputPhone').invalid
      || this.releaseLineForm.get('inputEmail').invalid
      || this.releaseLineForm.get('inputKeyNumber').invalid
      || this.releaseLineForm.get('inputLines').invalid
      || ((this.imei == "" || this.imei == null) && this.selectedType != constants.STRING_LINE)) {
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
      this.isShowModal = true;
      return;
    }

    if (!this.LANG.isValidPhoneZero(this.releaseLineForm.get('inputLines').value) ||
        !this.LANG.isValidPhoneZero(this.releaseLineForm.get('inputPhone').value)) {
      //si no tiene el prefijo 0 no puede seguir
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PHONE_VALIDATOR_ERROR_ZERO');
      this.isShowModal = true;
      return false;
    }

    const userData = JSON.parse(localStorage.getItem("userData"));
    let jsonData = {
      "identification": userData.documentId,
      "msisdn": this.releaseLineForm.get('inputLines').value,
      "imei": this.imei,
      "brand": this.phoneBrand,
      "model": this.phoneImei,
      "alternateMsisdn":  this.releaseLineForm.get('inputPhone').value,
      "email": this.releaseLineForm.get('inputEmail').value,
      "verificationKey": this.releaseLineForm.get('inputKeyNumber').value,
      "customerAccountId": userData.customerAccountId,
      "type": this.selectedType
    };

    this.isBtnDisabled = true;
    this.releaseLineEquipService.releaseLineEquipRequest(jsonData).subscribe((data => {
      //habilitar botones
      this.isBtnDisabled = false;
      if (data['responseCode'] == constants.RELEASE_NO_KEY) {
        this.isShowModalConfirmation = true;//Abre modal con opciones "intertar nuevamente", "probar otra manera"
        return;
      }
      if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_INFO');
        this.modalContent = this.LANG.getLangText('RELEASE_LINE_EQUIP_RELEASE_ERROR_REQUEST_FINAL');
        this.isShowModal = true;
        return;
      }

      this.isModalReload = true;
      // this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_INFO');
      // this.modalContent = this.LANG.getLangText('RELEASE_LINE_EQUIP_RELEASE_OK_REQUEST_FINAL') + data["obj"].ticket;
      this.isShowModalValid = true;

    }),
      (err) => {
        this.isBtnDisabled = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }
  /**
  * Description: Método que valida que los datos esten ingresados correctamente en el paso 2
  * Autor: Steven Sterling
  * @param N/A
  * @return N/A
  */
  // releaseValidationStepTwo() {
  //   console.log(this.questionSelectedModel);
  //   this.validateQuestions();
  //   if (this.validateQuestions()) {
  //     this.modalTitleConfirmationRelease = this.LANG.getLangText('RELEASE_LINE_EQUIP_RELEASEOK_STEP2');
  //     this.isShowModalValid = true;
  //   } else {
  //     this.modalTitleConfirmationRelease = this.LANG.getLangText('RELEASE_LINE_EQUIP_INCORRECT_KEY_TITLE');
  //     this.isShowModalInvalidAnswer = true;

  //   }
  // }
  /**
  * Description: Método que valida las preguntas con el WS
  * Autor: Steven Sterling
  * @param dto validar si son las preguntas y respuestas
  * @return respuesta del WS
  */
  validateQuestions() {
    //RESPUESTA DEL WS
    this.isBtnDisabled = true;
    const totalAnswer = this.questionSelectedModel.filter(value => value).length;
    if (totalAnswer !== this.listQuestions.length) {
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_INFO');
      this.modalContent = this.LANG.getLangText('RELEASE_LINE_EQUIP_ANSWER_UNSELECT');
      this.isShowModal = true;
    } else {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const dataJson = {
        identification: userData.documentId,
        msisdn: this.releaseLineForm.get('inputLines').value,
        results: this.questionSelectedModel
      };
      this.releaseLineEquipService.validateQuestions(dataJson).subscribe((data) => {

        if(data["responseCode"] == constants.SUCCESS_WS_RESPONSE_CODE) {
          if(data["obj"]["valid"]){
            this.isShowModalValid = true;
          } else {
            this.isShowModalInvalidAnswer = true            
          }
        } else {
          this.isBtnDisabled = false;
          this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
          this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
          this.isShowModal = true;

        }
        //habilitar botones
        this.isBtnDisabled = false;
      },
      (err) => {
        this.isLoadingLines = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
    }
  }


  /**
  * Description: Método que cierra el modal
  * Autor: Steven Sterling
  * @param N/A
  * @return N/A
  */
  hideModal() {
    this.isShowModal = false;
    this.isShowModalConfirmation = false;
    this.isShowModalValid = false;
    this.isShowModalInvalidAnswer = false;
    this.isBtnDisabled= false;
    if (this.isModalReload) {
      this._router.navigate(['/']);
    }
  }
  /**
  * Description: Método que setea la información de los tooltips de la página
  * Autor: Steven Sterling
  * @param N/A
  * @return N/A
  */
  setTooltips() {
    $('#tooltipMyLine').popover({
      html: true,
      title: 'Titulo MyLine',
      content: "Descripcion MyLine"
    });
    $('#tooltipPhoneNumber').popover({
      html: true,
      title: 'Titulo PhoneNumber',
      content: "Descripcion PhoneNumber"
    });
    $('#tooltipEmail').popover({
      html: true,
      title: 'Titulo Email',
      content: "Descripcion Email"
    });
    $('#tooltipKeyNumber').popover({
      html: true,
      title: 'Titulo KeyNumber',
      content: "Descripcion KeyNumber"
    });
  }
  /**
  * Description: Método que selecciona las respuestas para realizar la liberación
  * Autor: Steven Sterling
  * @param N/A
  * @return N/A
  */
  selectData(ev, x, y, data) {
    //Indica la respuesta segun la posicion y seleccionada de la pregunta numero x
    this.questionSelected[x] = y;
    this.questionSelectedModel[x] = data;
    let node2 = $(ev.currentTarget);
    node2.parent('label.container-tal').parent('div').siblings('div').children('label.container-tal').removeClass('is-checked');
    node2.parent('label.container-tal').addClass('is-checked');
  }
  /**
    * Description: Método que obtiene la informacion de las lineas del cliente con sus datos
    * Autor: Steven Sterling
    * @param N/A
    * @return N/A
    */
  getClientLinesLists() {
    const userData = JSON.parse(localStorage.getItem("userData"));
    let documentId = userData.documentId;
    const customerAccountId = userData.customerAccountId;
    this.isLoadingLines = true;
    this.releaseLineEquipService.getAllUserLines(customerAccountId).subscribe((data => {
      //habilitar botones
      this.isLoadingLines = false;
      if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('RELEASE_LINE_EQUIP_LABEL_MODAL_ERROR_NO_LINES');
        this.isShowModal = true;
        return;
      }
      //llena la lista
      let item = null;
      this.listLines = [];
      for (var k in data['obj'].basicDataOfMobileLine) {
        item = data['obj'].basicDataOfMobileLine[k];
        this.listLines.push({ "id": item.msisdn, "linea": item.msisdn });
      }
    }),
      (err) => {
        this.isLoadingLines = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }
  /**
  * Description: Método que realiza el el cambio de estilos al seleccionar opciones de liberación
  * Autor: Steven Sterling
  * @param N/A
  * @return N/A
  */
  chekckOptionsSelected() {
    //cambio de estilos al seleccionar opciones para liberación de linea
    $('.defaultOptionCheck').parent('.image-checkbox').addClass('image-checkbox-checked');
    $('.defaultOptionCheck').attr('checked', true);
    $('.optionCheck').on('change', e => {
      let nodeEl = $(e.target);
      $('.optionCheck').parent('.image-checkbox').removeClass('image-checkbox-checked');
      if ($(e.target).is(':checked')) {
        $(e.target).parent('.image-checkbox').addClass('image-checkbox-checked');
      }
    });
  }

  /**
  * Description: Método que selecciona el tipo de liberación
  * Autor: Steven Sterling
  * @param id identificado del tipo
  * @return N/A
  */
  setSelectedType(id) {
    this.selectedType = constants.STRING_LINE;
    if (id == 2) {
      this.selectedType = constants.STRING_EQUIP;
    } else if (id == 3) {
      this.selectedType = constants.STRING_LINE_EQUIP;
    }
  }

  /**
  * Description: Método que obtiene las preguntas para la liberación
  * Autor: Steven Sterling
  * @param N/A
  * @return N/A
  */
  getReleaseQuestions() {

    const userData = JSON.parse(localStorage.getItem("userData"));
    let documentId = userData.documentId;
    let msisdn = this.releaseLineForm.get('inputLines').value;
    let customerId = userData.customerAccountId;
    this.isLoadingQuestion = true;
    this.isBtnDisabled = true;
    this.releaseLineEquipService.getReleaseQuestionsList(documentId, msisdn, customerId).subscribe((data => {
      //habilitar botones
      this.isBtnDisabled = false;      
      this.isLoadingQuestion = false;
      if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {      
        this.isIncorrectKey = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('RELEASE_LINE_EQUIP_LABEL_MODAL_ERROR_NO_VERIFICATION_QUESTIONS');
        this.isShowModal = true;
        return;
      }
      this.listQuestions = data["obj"]["questions"];      
    }),
      (err) => {
        this.isBtnDisabled = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }

  /**
 * Description: Método que obtiene el imei y marca de una linea
 * Autor: Steven Sterling
 * @param N/A
 * @return N/A
 */
  handleImei() {

    this.phoneBrand = "";
    this.imei = "";
    this.phoneImei = "";
    this.selectedLine = false;
    //obtenemos la linea seleccionada con:
    this.isBtnDisabled = true;
    this.isLoadingLines = true;
    this.releaseLineEquipService.getInfoLines(this.releaseLineForm.get('inputLines').value).subscribe((data => {
      //habilitar botones
      this.isLoadingLines = false;
      this.isBtnDisabled = false;
      if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        return;
      }
      this.phoneBrand = data['obj'].brand;
      this.imei = data['obj'].imei;
      this.phoneImei = data['obj'].model;
      this.selectedLine = true;

    }),
      (err) => {
        this.isBtnDisabled = false;
        this.isLoadingLines = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }


  setIsIncorrectKey() {
    
    this.getReleaseQuestions();
    this.isIncorrectKey = true;
    this.isShowModalConfirmation = false;
  }

}
